exports.default = {
  'copy_code': '复制代码',
  'copy_success': '复制成功！',
  'copy_failed': '复制失败！',
  'image_save_success': '图片保存成功',
  'image_save_failed': '图片保存失败',
  'file_created': '文件已创建',
  'file_creating': '正在创建文件',
  'file_creation_stopped': '文件创建已停止',
  'action_finished': '操作已完成',
  'action_executing': '正在执行操作',
  'action_stopped': '操作已停止',
  'completed': '完成',
  'in_progress': '进行中',
  'stopped': '已停止'
}
